import React, {useState} from 'react';
import Loading from "../animations/Loading";

const NotFound = () => {
    const styles = {
        container: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            backgroundColor: '#00bf63',
            color: 'white',
            textAlign: 'center',
            padding: '20px',
            boxSizing: 'border-box',
        },
        title: {
            fontSize: '36px',
        },
        message: {
            fontSize: '20px',
            margin: '20px 0',
        },
        logoutButton: {
            padding: '10px 20px',
            fontSize: '18px',
            backgroundColor: 'white',
            color: '#00bf63',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            transition: 'background-color 0.3s',
        },
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.title}>
                Error, página no encontrada.
            </h1>
            <p style={styles.message}>
                Si crees que se trata de un error, contáctate con un administrador.
            </p>
        </div>
    );
};

export default NotFound;